const SCOPE = 'platform-group'

// PingFederate access token. Deliberately a different key from the legacy Auth0 token
// (`${SCOPE}/admin/token`) so tabs still running the pre-Kong/LIMA bundle keep their Auth0
// token until it expires naturally, instead of sending a PingFederate token to the old gateway.
export const AUTH_TOKEN_KEY = `${SCOPE}/admin/oidc-token`
export const USER_KEY = `${SCOPE}/admin/user`
export const DATAGRID_KEY = `${SCOPE}/datagrid`

export const CUSTOMER_ID = `${SCOPE}/admin/customer-id`
export const CUSTOMER_SORT_KEY = `${SCOPE}/admin/customers-sort`
